<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-combobox
          :items="tribes"
          item-value="name"
          item-text="name"
          label="Public"
          return-object
          v-model="pricing.tribe"
          solo
          flat
          outlined
          rounded
          class="mt-3"
        >
          <template v-slot:item="data">
            <v-list-item-content>{{ data.item.name }}</v-list-item-content>
          </template>
        </v-combobox>
      </v-col>

      <v-col cols="12">
        <v-alert v-if="error.setErr" type="error">{{ error.message }}</v-alert>
      </v-col>

      <v-col cols="4">
        <!-- Price now -->
        <div>
          <v-text-field
            type="text"
            placeholder="Current price (£)"
            v-model="pricing.price"
            outlined
            solo
            flat
            rounded
            persistent-hint
          ></v-text-field>
        </div>
      </v-col>

      <v-col cols="4">
        <!-- Price was -->
        <div>
          <v-text-field
            type="text"
            placeholder="New price (£)"
            v-model="pricing.previous"
            outlined
            solo
            flat
            rounded
            persistent-hint
          ></v-text-field>
        </div>
      </v-col>

      <v-col cols="4">
        <!-- Discount -->
        <div>
          <v-text-field
            type="text"
            placeholder="Discount (%)"
            v-model="pricing.discount"
            solo
            outlined
            flat
            rounded
            persistent-hint
          ></v-text-field>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: {
    tribes: Array,
    pricing: Object,
    rules: Object
  },

  data() {
    return {
      error: {
        setErr: false,
        message: ""
      }
    };
  },

  watch: {
    pricing: {
      handler: function(val) {
        if (isNaN(val.price) || isNaN(val.previous)) {
          this.error.setErr = true;
          this.error.message = "Number expected";
        } else if (val.price && val.price >= val.previous) {
          this.error.setErr = true;
          this.error.message = "New price must be less than old price";
        } else {
          this.error.setErr = false;
        }
      },
      deep: true
    }
  }
};
</script>

<style lang="scss" scoped></style>
